<template>
  <div @click="$emit('click')">
    <b-table-simple
      hover
      responsive
      bordered
      caption-top
    >
      <caption class="font-weight-bold text-primary">
        {{ caption }}
      </caption>
      <colgroup><col><col></colgroup>
      <colgroup><col><col><col></colgroup>
      <colgroup><col><col></colgroup>
      <b-thead>
        <b-tr>
          <b-th>Total</b-th>
          <b-th>Completed</b-th>
          <b-th>Percentage</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-th rowspan="2">
            {{ stats.total }}
          </b-th>
          <b-th class="text-success">
            {{ stats.withoutPromo.count }}
          </b-th>
          <b-td class="text-success font-weight-bold">
            {{ isNaN(stats.withoutPromo.percentage) || stats.withoutPromo.percentage === null ? '_': `${stats.withoutPromo.percentage.toFixed(2)} %` }}
          </b-td>
        </b-tr>

        <b-tr>
          <b-th class="font-weight-bold text-info">
            {{ stats.withPromo.count }}
          </b-th>
          <b-td class="font-weight-bold text-info">
            {{ isNaN(stats.withPromo.percentage) || stats.withPromo.percentage === null ? '_' : `${stats.withPromo.percentage.toFixed(2)} %` }}
          </b-td>
        </b-tr>

        <template v-if="tillNow">
          <b-tr>
            <b-th rowspan="2">
              {{ tillNow.total }} (*)
            </b-th>
            <b-th class="text-success">
              {{ tillNow.withoutPromo.count }}
            </b-th>
            <b-td class="text-success font-weight-bold">
              {{ isNaN(tillNow.withoutPromo.percentage) || tillNow.withoutPromo.percentage === null ? '_' : `${tillNow.withoutPromo.percentage.toFixed(2)} %` }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th class="font-weight-bold text-info">
              {{ tillNow.withPromo.count }}
            </b-th>
            <b-td class="font-weight-bold text-info">
              {{ isNaN(tillNow.withPromo.percentage) || tillNow.withPromo.percentage === null ? '_' : `${tillNow.withPromo.percentage.toFixed(2)} %` }}
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import {
  BTableSimple, BTd, BTr, BTh, BTbody, BThead,
} from 'bootstrap-vue'

export default {
  components: {
    BTableSimple, BTd, BTr, BTh, BTbody, BThead,
  },
  props: {
    caption: {
      type: String,
      required: true,
    },
    stats: {
      type: Object,
      required: true,
      description: 'Contains the total records/ total with promo/without promo',
    },
    tillNow: {
      type: Object,
      default: undefined,
    },
  },
}
</script>

<style scoped>
th, td {
    text-align: center;
}
</style>
